import { render, staticRenderFns } from "./CompareCountryHeader.vue?vue&type=template&id=37e9838c&scoped=true&"
import script from "./CompareCountryHeader.vue?vue&type=script&lang=js&"
export * from "./CompareCountryHeader.vue?vue&type=script&lang=js&"
import style0 from "./CompareCountryHeader.vue?vue&type=style&index=0&id=37e9838c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e9838c",
  null
  
)

export default component.exports